import React from "react";
// externel packge
import { Navigate, useLocation } from "react-router-dom";
// files

const PrivateRoute = ({ children, ...rest }) => {
  let location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} />;
  }
  return children;
};

export default PrivateRoute;
